import { Component, Input, OnInit } from '@angular/core';
import { InventoryActionFormComponent } from '../inventory-action-form.component';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-inventory-action-for-pricing-form',
    templateUrl: './inventory-action-for-pricing-form.component.html',
    styleUrl: './inventory-action-for-pricing-form.component.scss',
    standalone: false
})
export class InventoryActionForPricingFormComponent extends InventoryActionFormComponent implements OnInit {
  @Input() requiredProducts;

  displayedColumns = {
    select: 'Seleccionar',
    name: 'Producto',
    alternative: 'Alternativo',
    required_quantity: 'Cantidad Requerida',
    quantity: 'Cantidad a ofrecer',
    flexible: 'Flexible',
    amount: 'Precio unitario',
    total: 'Total',
  };

  expirationOptions = [
    { label: '7 días', value: 7 },
    { label: '15 días', value: 15 },
    { label: '30 días', value: 30 },
  ];

  country = this.adminService.local$.getValue().country;

  defaultOption = 15;

  expirationDate: Date = this.calculateDate(this.defaultOption);

  get expirationDateControl() {
    return this.parentFormGroup.get('expiration_date') as FormControl;
  }

  get humanColumnsNames() {
    return Object.values(this.displayedColumns);
  }

  get columnsNames() {
    return Object.keys(this.displayedColumns);
  }

  get requiredDeliveryDate() {
    return this.parentFormGroup.getRawValue()?.extra_params?.required_delivery_date
  }

  get showDatesWarning() {
    return moment(this.estimatedCompletionDateControl.value).isAfter(this.requiredDeliveryDate);
  }

  ngOnInit(): void {
    super.ngOnInit();
    
    this.setChecked();
  }


  addFormHandlersAndValidators(controlGroup: FormGroup) {
    super.addFormHandlersAndValidators(controlGroup);

    controlGroup.get('quantity').setValidators([Validators.required, Validators.min(0)]);
    controlGroup.get('quantity').updateValueAndValidity();
    
    if (this.completed) {
      controlGroup.get('extra_params')?.disable();
    }
  }

  getRequiredProduct(id) {
    return this.requiredProducts.find(product => product.product_id === id);
  }

  setChecked() {
    this.parentFormArray.controls.forEach((group: FormGroup) => {
      const productData = group.getRawValue();
      group.addControl(
        'checked',
        new FormControl(productData.quantity > 0 ? true : false)
      );

      if (this.completed) {
        group.get('checked').disable();
      } else {
        group.get('checked').valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((checked) => {
          if (checked) {
            group.get('quantity').setValue(this.getRequiredProduct(productData.product_id).quantity);
            group.get('amount').enable();
            group.get('extra_params.flexible').enable();
            group.get('extra_params.alternative').enable();
          } else {
            group.get('amount').disable();
            group.get('extra_params.flexible').disable();
            group.get('extra_params.alternative').disable();
            group.get('quantity').setValue(0);
          }
        });
      }

    });
  }

  calculateDate(days: number): Date {
    const currentDate = new Date();
    return new Date(currentDate.setDate(currentDate.getDate() + days));
  }

  onDaysChange(days: number): void {
    this.expirationDate = this.calculateDate(days);
    this.expirationDateControl.setValue(this.expirationDate);
  }

  get Total(): number {
    let total = 0;
  
    this.categories.forEach(category => {
      const formArray = this.getCategoryFormArray(category.id);
      if (formArray) {
        formArray.controls.forEach(control => {
          const quantity = control.get('quantity')?.value || 0;
          const amount = control.get('amount')?.value || 0;
            total += quantity * amount;
        });
      }
    });
  
    return total;
  }
}
